<template>
  <div id="app"><router-view /></div>
</template>

<style type="text/css">
object[type^="application/gas"] {
  display: none;
}
.modal-close {
  background-color: #999999 !important;
}
.modal-close:hover {
  background-color: #666666 !important;
}
body.chain-mq .switch input[type="checkbox"] + .check.is-secondary-passive {
  background-color: #133b23;
}
body.chain-mq
  .switch
  input[type="checkbox"]
  + .check.is-secondary-passive:hover {
  background-color: #133b23;
}
body.chain-mq input.input:focus,
body.chain-mq textarea.textarea:focus,
body.chain-mq .select select:focus {
  border-color: #f2be46 !important;
  box-shadow: 0 0 0.4em 0 rgba(0, 0, 0, 0.1), 0 0 0.15em 0 #f2be46 !important;
}
body.chain-mq
  .switch
  input[type="checkbox"]:focus
  + .check.is-secondary-passive,
body.chain-mq
  .switch
  input[type="checkbox"]:active
  + .check.is-secondary-passive {
  box-shadow: 0 0 0.5em rgba(19, 59, 35, 0.8);
}
body.chain-mq .switch input[type="checkbox"]:checked + .check.is-primary {
  background-color: #f2be46;
}
body.chain-mq .switch input[type="checkbox"]:focus + .check.is-primary,
body.chain-mq .switch input[type="checkbox"]:active + .check.is-primary,
body.chain-mq .switch input[type="checkbox"]:focus:checked + .check.is-primary,
body.chain-mq
  .switch
  input[type="checkbox"]:active:checked
  + .check.is-primary {
  box-shadow: 0 0 0.5em rgba(242, 190, 70, 0.8);
}
body.chain-mq
  .switch
  input[type="checkbox"]
  + .check.is-primary:not(.is-secondary-passive) {
  background-color: #f2be46 !important;
  border-color: #f2be46 !important;
}
body.chain-mq
  .switch
  input[type="checkbox"]:focus
  + .check.is-primary:not(.is-secondary-passive),
body.chain-mq
  .switch
  input[type="checkbox"]:active
  + .check.is-primary:not(.is-secondary-passive),
body.chain-mq
  .switch
  input[type="checkbox"]:focus:checked
  + .check.is-primary:not(.is-secondary-passive),
body.chain-mq
  .switch
  input[type="checkbox"]:active:checked
  + .check.is-primary:not(.is-secondary-passive) {
  box-shadow: 0 0 0.5em rgba(242, 190, 70, 0.8);
}
body.chain-mq .is-primary:not(.check) {
  /* background-color: #f2be46 !important; */
  border-color: #f2be46 !important;
}
body.chain-mq .has-text-primary {
  color: #f2be46 !important;
}
body.chain-mq .b-radio.radio input[type="radio"] + .check.is-primary:before {
  background-color: #f2be46;
}
body.chain-mq .b-radio.radio input[type="radio"]:checked + .check.is-primary {
  border-color: #f2be46;
}
body.chain-mq
  .b-radio.radio
  input[type="radio"]:focus:checked
  + .check.is-primary {
  box-shadow: 0 0 0.5em rgba(242, 190, 70, 0.8);
}
body.chain-mq .select:not(.is-multiple):not(.is-loading)::after,
body.chain-mq .navbar-link:not(.is-arrowless)::after {
  border-color: #f2be46;
}
body.chain-mq
  .b-radio.radio
  input[type="radio"]
  + .check:not(.is-white, .is-black, .is-light, .is-dark, .is-primary, .is-link, .is-info, .is-success, .is-warning, .is-danger):before {
  background-color: #f2be46;
}
body.chain-mq
  .b-radio.radio
  input[type="radio"]:checked
  + .check:not(.is-white, .is-black, .is-light, .is-dark, .is-primary, .is-link, .is-info, .is-success, .is-warning, .is-danger) {
  border-color: #f2be46;
}
body.chain-mq
  .b-radio.radio
  input[type="radio"]:focus:checked
  + .check:not(.is-white, .is-black, .is-light, .is-dark, .is-primary, .is-link, .is-info, .is-success, .is-warning, .is-danger) {
  box-shadow: 0 0 0.5em rgba(242, 190, 70, 0.8);
}
</style>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$smart-orange: #f0512d;
$smart-orange-invert: findColorInvert($smart-orange);

$smart-orange-1: #fff4f2;
$smart-orange-1-invert: findColorInvert($smart-orange-1);

$smart-orange-2: #ffcdbe;
$smart-orange-2-invert: findColorInvert($smart-orange-2);

$smart-orange-3: #ffa68c;
$smart-orange-3-invert: findColorInvert($smart-orange-3);

$smart-orange-4: #fc7e5c;
$smart-orange-4-invert: findColorInvert($smart-orange-4);

$smart-orange-5: #f0512d;
$smart-orange-5-invert: findColorInvert($smart-orange-5);

$smart-orange-6: #d24428;
$smart-orange-6-invert: findColorInvert($smart-orange-6);

$smart-orange-7: #b53723;
$smart-orange-7-invert: findColorInvert($smart-orange-7);

$smart-orange-8: #992a1e;
$smart-orange-8-invert: findColorInvert($smart-orange-8);

$smart-orange-9: #7e1e19;
$smart-orange-9-invert: findColorInvert($smart-orange-9);

$deep-purple: #50273a;
$deep-purple-invert: findColorInvert($deep-purple);

$deep-purple-1: #fff2fb;
$deep-purple-1-invert: findColorInvert($deep-purple-1);

$deep-purple-2: #dcc4d3;
$deep-purple-2-invert: findColorInvert($deep-purple-2);

$deep-purple-3: #ba97ac;
$deep-purple-3-invert: findColorInvert($deep-purple-3);

$deep-purple-4: #986c87;
$deep-purple-4-invert: findColorInvert($deep-purple-4);

$deep-purple-5: #774363;
$deep-purple-5-invert: findColorInvert($deep-purple-5);

$deep-purple-6: #6a3955;
$deep-purple-6-invert: findColorInvert($deep-purple-6);

$deep-purple-7: #5d3047;
$deep-purple-7-invert: findColorInvert($deep-purple-7);

$deep-purple-8: #50273a;
$deep-purple-8-invert: findColorInvert($deep-purple-8);

$deep-purple-9: #441e2d;
$deep-purple-9-invert: findColorInvert($deep-purple-9);

$elegant-black: #242525;
$elegant-black-invert: findColorInvert($elegant-black);

$elegant-black-1: #f6f6f6;
$elegant-black-1-invert: findColorInvert($elegant-black-1);

$elegant-black-2: #f0f0f0;
$elegant-black-2-invert: findColorInvert($elegant-black-2);

$elegant-black-3: #cfd0d0;
$elegant-black-3-invert: findColorInvert($elegant-black-3);

$elegant-black-4: #b0b0b0;
$elegant-black-4-invert: findColorInvert($elegant-black-4);

$elegant-black-5: #919292;
$elegant-black-5-invert: findColorInvert($elegant-black-5);

$elegant-black-6: #747474;
$elegant-black-6-invert: findColorInvert($elegant-black-6);

$elegant-black-7: #585858;
$elegant-black-7-invert: findColorInvert($elegant-black-7);

$elegant-black-8: #3d3e3e;
$elegant-black-8-invert: findColorInvert($elegant-black-8);

$elegant-black-9: #242525;
$elegant-black-9-invert: findColorInvert($elegant-black-9);

$pink: #ef4365;
$pink-invert: findColorInvert($pink);

$blue: #1e3e6f;
$blue-invert: findColorInvert($blue);

$sea: #00b2a7;
$sea-invert: findColorInvert($sea);

$light-green: #d9f2d9;
$light-green-invert: findColorInvert($light-green);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "secondary": (
    $secondary,
    $secondary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "smart-orange": (
    $smart-orange,
    $smart-orange-invert
  ),
  "smart-orange-1": (
    $smart-orange-1,
    $smart-orange-1-invert
  ),
  "smart-orange-2": (
    $smart-orange-2,
    $smart-orange-2-invert
  ),
  "smart-orange-3": (
    $smart-orange-3,
    $smart-orange-3-invert
  ),
  "smart-orange-4": (
    $smart-orange-4,
    $smart-orange-4-invert
  ),
  "smart-orange-5": (
    $smart-orange-5,
    $smart-orange-5-invert
  ),
  "smart-orange-6": (
    $smart-orange-6,
    $smart-orange-6-invert
  ),
  "smart-orange-7": (
    $smart-orange-7,
    $smart-orange-7-invert
  ),
  "smart-orange-8": (
    $smart-orange-8,
    $smart-orange-8-invert
  ),
  "smart-orange-9": (
    $smart-orange-9,
    $smart-orange-9-invert
  ),
  "deep-purple": (
    $deep-purple,
    $deep-purple-invert
  ),
  "deep-purple-1": (
    $deep-purple-1,
    $deep-purple-1-invert
  ),
  "deep-purple-2": (
    $deep-purple-2,
    $deep-purple-2-invert
  ),
  "deep-purple-3": (
    $deep-purple-3,
    $deep-purple-3-invert
  ),
  "deep-purple-4": (
    $deep-purple-4,
    $deep-purple-4-invert
  ),
  "deep-purple-5": (
    $deep-purple-5,
    $deep-purple-5-invert
  ),
  "deep-purple-6": (
    $deep-purple-6,
    $deep-purple-6-invert
  ),
  "deep-purple-7": (
    $deep-purple-7,
    $deep-purple-7-invert
  ),
  "deep-purple-8": (
    $deep-purple-8,
    $deep-purple-8-invert
  ),
  "deep-purple-9": (
    $deep-purple-9,
    $deep-purple-9-invert
  ),
  "elegant-black": (
    $elegant-black,
    $elegant-black-invert
  ),
  "elegant-black-1": (
    $elegant-black-1,
    $elegant-black-1-invert
  ),
  "elegant-black-2": (
    $elegant-black-2,
    $elegant-black-2-invert
  ),
  "elegant-black-3": (
    $elegant-black-3,
    $elegant-black-3-invert
  ),
  "elegant-black-4": (
    $elegant-black-4,
    $elegant-black-4-invert
  ),
  "elegant-black-5": (
    $elegant-black-5,
    $elegant-black-5-invert
  ),
  "elegant-black-6": (
    $elegant-black-6,
    $elegant-black-6-invert
  ),
  "elegant-black-7": (
    $elegant-black-7,
    $elegant-black-7-invert
  ),
  "elegant-black-8": (
    $elegant-black-8,
    $elegant-black-8-invert
  ),
  "elegant-black-9": (
    $elegant-black-9,
    $elegant-black-9-invert
  ),
  "card-valid": (
    rgb(57, 145, 61),
    $dark
  ),
  "card-expiring": (
    rgb(228, 108, 10),
    $dark
  ),
  "card-expired": (
    rgb(160, 89, 31),
    $dark
  ),
  "card-blocked": (
    $danger,
    $danger-invert
  ),
  "sensitive-data": (
    rgb(100, 100, 100),
    $dark
  ),
  "pink": (
    $pink,
    $pink-invert
  ),
  "blue": (
    $blue,
    $blue-invert
  ),
  "sea": (
    $sea,
    $sea-invert
  ),
  "light-green": (
    $light-green,
    $light-green-invert
  )
);

// Font Family
@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-regular.ttf");
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-extra-light.ttf");
  font-weight: 200;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-light.ttf");
  font-weight: 300;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-regular.ttf");
  font-weight: 400;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-medium.ttf");
  font-weight: 500;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-semi-bold.ttf");
  font-weight: 600;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-bold.ttf");
  font-weight: 700;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-extra-bold.ttf");
  font-weight: 800;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-black.ttf");
  font-weight: 900;
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-italic.ttf");
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-extra-light-italic.ttf");
  font-weight: 200;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-light-italic.ttf");
  font-weight: 300;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-italic.ttf");
  font-weight: 400;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-medium-italic.ttf");
  font-weight: 500;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-semi-bold-italic.ttf");
  font-weight: 600;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-bold-italic.ttf");
  font-weight: 700;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-extra-bold-italic.ttf");
  font-weight: 800;
  font-style: "italic";
}

@font-face {
  font-family: "muli";
  src: url("./assets/fonts/muli-black-italic.ttf");
  font-weight: 900;
  font-style: "italic";
}

$family-primary: "muli", $family-sans-serif;
$family-secondary: "muli", $family-sans-serif;

$weight-extralight: 200;
$weight-extrabold: 800;
$weight-black: 900;

// Tabs
$tabs-toggle-link-border-color: $black;

// Input
$input-focus-border-color: $primary;
$input-focus-box-shadow-color: rgba($primary, 0.25);
$input-arrow: $primary;

// Pagination
$pagination-current-background-color: $primary;
$pagination-current-border-color: $pagination-curr-border-color;

// Import Bulma and Buefy
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<script>
import i18n from "./i18n";

export default {
  mounted() {
    if (
      !this.$store.getters.locale ||
      !i18n.messages.hasOwnProperty(this.$store.getters.locale)
    ) {
      let currentLocale = navigator.language.replace("-", "_");
      if (!i18n.messages.hasOwnProperty(currentLocale)) {
        if (
          i18n.fallbackLocale.default &&
          i18n.fallbackLocale.default.length > 0
        ) {
          currentLocale = i18n.fallbackLocale.default[0];
        }
      }
      this.$store.dispatch("setLocale", currentLocale);
    }
  }
};
</script>
